import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { PermissionService } from '../services/permission.service';

export const integrationsPermissionGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const user = authService.loggedUser$.value;

  if (!user || !user.roles || user.roles.length === 0) {
    router.navigateByUrl('/auth/company-select');
    return false;
  }

  if (!permissionService.canAccessIntegrations()) {
    router.navigateByUrl('/auth/company-select');
    return false;
  }

  return true;
};
